import { useMutation, UseQueryOptions } from "react-query";
import { getConfig } from "../config";

async function updateLoan(data: LoanUpdate) {
  const { apiUrl, apiKey } = getConfig();
  let url = `${apiUrl}/loans/${data.id}/`;
  const headers = {
    "X-Locker-Token": apiKey,
    "Content-Type": "application/json",
  };
  const response = await fetch(url, {
    headers,
    method: "PATCH",
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Network Error");
  }
  return response.json();
}

export function useUpdateLoan(options?: UseQueryOptions) {
  return useMutation((data: LoanUpdate) => updateLoan(data), options as any);
}
